import React from "react"
import styled, { keyframes } from "styled-components";
import { useLanguageState } from "../../globalStates/LanguageState";
import { formatPercetage } from "../../utils/Numbers";

const rotate = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

const Loader = styled.div`
	border: 2px solid;
	border-left-color: #ffffff;
	transform: translateZ(0);
	animation: ${rotate} 1.1s infinite linear;
		
	&,
	&:after {
		border-radius: 50%;
		width: 40px;
		height: 40px;
	}
`;

const Progress = styled.div`
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    z-index:10;
    font-size:14px;
    font-weight:400;
    color: #202428;
`

interface LoadingProps {
    mainColor: string
}

const LoadingWrapper = styled.div<LoadingProps>`
	position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    color: ${props => props.mainColor || "#6DD400"};
`

interface LoadingIndicatorProps {
    progress: number | null
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ progress }) => {
    const branding = useLanguageState().getStrings()
    return (
        <LoadingWrapper mainColor={branding.configuration.maincolor} id="loading-indicator">
            {progress && <Progress>{formatPercetage(progress)}</Progress>}
            <Loader color={branding.configuration.maincolor} />
        </LoadingWrapper>
    )
}

export default LoadingIndicator